import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {},
  noChats: {
    padding: "1em 0",
    textAlign: "center",
  },
}));
